var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftImag1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2171_2525)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2171_2525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 35C22.4972 34.9999 21.0291 34.5483 19.786 33.7037C18.5429 32.8592 17.5822 31.6606 17.0284 30.2635C16.4747 28.8664 16.3534 27.3352 16.6804 25.8683C17.0073 24.4015 17.7674 23.0667 18.8621 22.037C20.2041 20.774 23.5001 18.5 23.0001 13.5C29.0001 17.5 32.0001 21.5 26.0001 27.5C27.0001 27.5 28.5001 27.5 31.0001 25.03C31.2701 25.803 31.5001 26.634 31.5001 27.5C31.5001 29.4891 30.7099 31.3968 29.3034 32.8033C27.8969 34.2098 25.9892 35 24.0001 35Z",
    fill: "#FA4A0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 35C22.4972 34.9999 21.0291 34.5483 19.786 33.7037C18.5429 32.8592 17.5822 31.6606 17.0284 30.2635C16.4747 28.8664 16.3534 27.3352 16.6804 25.8683C17.0073 24.4015 17.7674 23.0667 18.8621 22.037C20.2041 20.774 23.5001 18.5 23.0001 13.5C29.0001 17.5 32.0001 21.5 26.0001 27.5C27.0001 27.5 28.5001 27.5 31.0001 25.03C31.2701 25.803 31.5001 26.634 31.5001 27.5C31.5001 29.4891 30.7099 31.3968 29.3034 32.8033C27.8969 34.2098 25.9892 35 24.0001 35Z",
    fill: "url(#paint0_linear_2171_2525)",
    fillOpacity: 0.24
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#E9EBF1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2171_2525",
    x1: 24.0001,
    y1: 13.5,
    x2: 24.0001,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2171_2525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2171_2525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftImag1);
export default __webpack_public_path__ + "static/media/LeftImag1.46ef4ee0c7f1e3c05bf8600ed0e7a73c.svg";
export { ForwardRef as ReactComponent };